<template>
    <div class="stat-row">
      <div class="section" :title="weekAgoDate">
        WoW:
        <strong :class="getDirectionClass(weekAgoValue)">
          {{ getDiffValue(weekAgoValue) }}
        </strong>
      </div>
      <div class="section" :title="monthAgoDate">
        MoM:
        <strong :class="getDirectionClass(monthAgoValue)">
          {{ getDiffValue(monthAgoValue) }}
        </strong>
      </div>
      <div class="section" :title="yearAgoDate">
        YoY:
        <strong :class="getDirectionClass(yearAgoValue)">
          {{ getDiffValue(yearAgoValue) }}
        </strong>
      </div>
    </div>
</template>

<script>
  import moment from 'moment'
  import {formatFloat, formatPercent, formatVolume} from '@/shared/number-utils'

  export default {
    name: 'graph-periodic-stat',
    components: {
    },
    props: {
      dates: {
        type: Array,
        default: () => [],
      },
      values: {
        type: Array,
        default: () => [],
      },
      currentDataIndex: {
        type: Number,
        default: () => null,
      },
      valuesFormat: {
        type: String,
        default: () => 'unset',
      },
    },
    data: function () {
      return {
      };
    },
    methods: {
      getNearestDateIndex(searchDate) {
        return this.dates.findIndex(date => {
          return date === searchDate.format('YYYY-MM-DD');

          /*
          let currentDate = moment(date, 'YYYY-MM-DD');
          let inRange = currentDate.isBetween(
            searchDate, searchDate.add(toleranceDuration), null, '[]'
          );
          if(inRange) {
            return true;  // left range
          }
          */
        });
      },

      getOffsetDate(duration) {
        // duration: moment.js offset like: 7 days
        // toleranceDuration: allowed tolerance duration

        // since moment date object is modified inplace we need to clone its objects
        let searchDate = this.currentDate.clone().subtract(duration);
        let index = this.getNearestDateIndex(searchDate);
        let requiredDate = this.dates[index];

        if(requiredDate) {
          return requiredDate;
        } else {
          return '--';
        }
      },

      getOffsetValue(duration) {
        // duration: moment.js offset like: 7 days
        // since moment date object is modified inplace we need to clone its objects
        let searchDate = this.currentDate.clone().subtract(duration);
        let index = this.getNearestDateIndex(searchDate);
        let requiredValue = this.values[index];

        if(requiredValue) {
          return requiredValue;
        } else {
          return null;
        }
      },

      getDiffValue(value) {
        if(value) {
          let convertedValue = Math.abs(this.currentValue - value);
          return this.getFormattedValue(convertedValue);
        } else {
          return '--';
        }
      },

      getDirectionClass(value) {
        if(value) {
          let diff = this.currentValue - value;
          if(diff > 0) {
            return 'growth';
          } else if (diff === 0) {
            return '';
          } else {
            return 'decline'
          }
        }
      },

      getFormattedValue(value) {
        if(typeof value !== 'number' && !value) {
          return '--';
        }

        if(value >= 1000) {
          return formatVolume(value, '100k');
        }

        if(this.valuesFormat === 'percent') {
          return formatPercent(value);
        }

        if(this.valuesFormat.startsWith('float')) {
          const regexp = this.valuesFormat.match(/float(\d+)/);
          const repeatCount = regexp ? regexp[1] : 1;
          return formatFloat(value, '0.' + '0'.repeat(repeatCount));
        }

        return Number.isInteger(value) ? value : value.toFixed(1);
      },
    },
    computed: {
      currentDate() {
        let dateString = this.dates[this.currentDataIndex];
        // returns moment date object
        return moment(dateString, 'YYYY-MM-DD');
      },
      currentValue() {
        return this.values[this.currentDataIndex];
      },

      weekAgoDate() {
        return this.getOffsetDate(moment.duration(7, 'days'));
      },
      weekAgoValue() {
        return this.getOffsetValue(moment.duration(7, 'days'));
      },

      monthAgoDate() {
        return this.getOffsetDate(moment.duration(1, 'months'));
      },
      monthAgoValue() {
        return this.getOffsetValue(moment.duration(1, 'months'));
      },

      yearAgoDate() {
        return this.getOffsetDate(moment.duration(1, 'years'));
      },
      yearAgoValue() {
        return this.getOffsetValue(moment.duration(1, 'years'));
      }
    },
  }
</script>

<style scoped lang="scss">
  .stat-row {
    display: flex;
    justify-content: space-between;
    min-width: 300px;
    margin-right: 10px;
    padding: 5px 0;

    .section {
      font-size: 15px;
      color: darkgray;
    }
    .growth {
      color: #00be41;
    }
    .growth::before {
      content: '\2191';
      color: #00be41;
      font-size: 18px;
      margin-right: -3px;
      line-height: 20px;
    }
    .decline {
      color: #d01410;
    }
    .decline::before {
      content: '\2193';
      color: #d01410;
      font-size: 18px;
      margin-right: -3px;
      line-height: 20px;
    }
  }

</style>
